import{ZipOperator as r}from"../observable/zip.js";function n(n){return function(t){return t.lift(new r(n))}}export{n as zipAll};
